import { countryDropdownComponents } from "../../../../../common/country-dropdown/countryDropdownComponents";
import { useSenderReceiverCountryOptions } from "../../../../../common/graphql/useSenderReceiverCountryOptions";
import { transformSenderReceiverCountryOption } from "../../../../../common/utils/optionTransformers";
import type { BookingFormState } from "../../../../../services/update-form/updateFormReducer";
import { DropdownField, type DropdownFieldProps } from "./DropdownField";

type Keys = Pick<BookingFormState, "receiverCountry" | "senderCountry">;

interface SenderReceiverCountryFieldProps<Key extends keyof Keys> extends Omit<
  DropdownFieldProps<Key>,
  "components" | "transformOption" | "options" | "filterOption"
> {}

export function SenderReceiverCountryField<Key extends keyof Keys>(
  props: SenderReceiverCountryFieldProps<Key>,
) {
  const [options] = useSenderReceiverCountryOptions({
    includeInvalidCountries: true,
  });

  return (
    <DropdownField
      {...props}
      options={options}
      components={countryDropdownComponents}
      filterOption={(o) => o.data.data.isValid}
      transformOption={transformSenderReceiverCountryOption}
    />
  );
}
